module.exports = __webpack_public_path__ + "static/happy-pets-30912ef32f46aee729ac3f5082d52054.jpg";